import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConstantsService } from './constants.service';
import { DataService } from './data.service';
import { UrlConstants } from './url-constants';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  public currentAuthUser = '';
  public currentAuthUserEmail = '';
  public currentUserObjectValues: any;
  video = new Subject<any>();
  cast = this.video.asObservable();
  message;
  creatorObj = new BehaviorSubject<any>({});
  creatorObservable = this.creatorObj.asObservable();
  hideSkeletonForUserProfileObj = new Subject<boolean>();
  hideSkeletonForUserProfileObservable = this.hideSkeletonForUserProfileObj.asObservable();
  isAdmin: boolean;
  convertedDate: number;
  constructor(
    private dataService: DataService,
    private urlConstants: UrlConstants,
    public constants: ConstantsService
  ) { }
  async getVideoList(status) {
    const params = [
      { param: '{object}', value: this.constants.GET_LIST },
      { param: '{id1}', value: status },
      { param: '{id2}', value: this.constants.GET_LIST },
    ];
    await this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .toPromise()
      .then((data) => {
        data['Items'].sort(
          (x, y) => +new Date(x.createdAt) - +new Date(y.createdAt)
        );
        this.video.next(data);
      })
      .catch((err) => { });
  }
  async updateSubmit(attributes) {
    const params = [
      { param: '{object}', value: this.constants.SMALL_SUBMIT_TXT },
    ];
    const dateStr = attributes[0].dateRecording;
    this.convertedDate = Date.parse(dateStr) / 1000;
    const bodyObj = {
      videoName: attributes[0].videoName,
      commonKey: attributes[0].commonKey,
      videoStatus: attributes[0].videoStatus,
      lastFolder: attributes[0].lastFolder,
      message: attributes[0].message,
      otherStatus: attributes[0].otherStatus,
      nickName: attributes[0].nickName,
      cityLocation: attributes[0].cityLocation,
      country: attributes[0].country,
      emailId: attributes[0].emailId,
      dateRecording: attributes[0].dateRecording,
      timeRecording: attributes[0].timeRecording,
      tag: attributes[0].tag,
      videoFolder : attributes[0].videoFolder,
      videoUrl : attributes[0].videoUrl,
      thumbnail:attributes[0].thumbnail,
      stats: attributes[0].stats,
      rejectionStatus: attributes[0].rejectionStatus,
      vimeoToken: attributes[0].vimeoToken
    };

    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async EditName(attributes) {
    const params = [
      { param: '{object}', value: this.constants.SMALL_SUBMIT_TXT },
    ];
    const bodyObj = {
      videoName: attributes[0].videoName,
      commonKey: attributes[0].commonKey,
      nickName: attributes[0].updatedNickname,
      cityLocation: attributes[0].updatedLocation,
      country: attributes[0].updatedCountry,
      videoTitle: attributes[0].updatedTitle,
      otherStatus: attributes[0].otherStatus,
      tag: attributes[0].tags,
      timeRecording: attributes[0].updatedTimeRecording,
      dateRecording: attributes[0].updatedDateRecording,
    };
    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async getUploadedVideo() {
    const params = [
      { param: '{object}', value: 'getAllVideos' },
      { param: '{id1}', value: 'window' },
      { param: '{id2}', value: 'getAllVideos' },
    ];
    return await this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .toPromise();
  }
  async getCityVideo() {
    const params = [
      { param: '{object}', value: 'getAllVideos' },
      { param: '{id1}', value: 'window' },
      { param: '{id2}', value: 'getAllVideos' },
    ];
    return await this.dataService
      .getData(this.urlConstants.getUri(this.urlConstants.getList, params))
      .toPromise();
  }
  async UpdateVideoTable(attributes) {
    const params = [{ param: '{object}', value: 'videos' }];
    const bodyObj = {
      campaignId: 'window',
      videoId: attributes[0].videoId,
      videoType: attributes[0].videoType,
    };
    await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.updateItem, params),
        JSON.stringify(bodyObj)
      )
      .toPromise();
  }
  async generatePresignedUrl(videoName, status) {
    const postParams = [
      { param: '{actionName}', value: 'getPreSignedVdeoUrl' },
    ];
    const postdata = {
      fileName: videoName,
      status: status,
      expires: 3600,
    };
    return await this.dataService.postData(
      this.urlConstants.getUri(this.urlConstants.action, postParams),
      postdata
    );
  }
  shareUserData(data) {
    this.message = data;
    this.creatorObj.next(data);
  }
  getSharedUserData() {
    return this.message;
  }
  getItemsFromSheet = async (sheetName) => {
    const postParams = [{ param: '{actionName}', value: 'getSheet' }];
    const postdata = { sheetName };
    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.action, postParams),
        postdata
      )
      .toPromise();
  };
  getItemsFromSheetOnFirstLoad = async () => {
    const postParams = [{ param: '{actionName}', value: 'getSheetNames' }];
    return await this.dataService
      .postData(this.urlConstants.getUri(this.urlConstants.action, postParams))
      .toPromise();
  };
  addItemsToSheet = async (postdata) => {
    const postParams = [{ param: '{actionName}', value: 'updateSheet' }];
    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.action, postParams),
        postdata
      )
      .toPromise();
  };
  deleteItemsToSheet = async (postdata) => {
    const postParams = [{ param: '{actionName}', value: 'deleteSheetRow' }];
    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.action, postParams),
        postdata
      )
      .toPromise();
  };
  postToVimeo = async (postdata) => {
    const postParams = [{ param: '{object}', value: 'videos' }];
    return await this.dataService
      .postData(
        this.urlConstants.getUri(this.urlConstants.createItem, postParams),
        postdata
      )
      .toPromise();
  };

  hideUserProfileSkeleton() {
    this.hideSkeletonForUserProfileObj.next(true);
  }
}
